import { useAppDispatch, useAppSelector } from '../../useReduxToolkit';
import * as realtime from '../../../features/realtime/realtime.slice';
import { RealtimeMessageType } from '../../../features/realtime/realtime.types';
import { ScreenshareRequestPayload } from '../screenshareState.types';
import { getCurrentRequestedMember } from '../../../features/screenshare/screenshare.selectors';
import { setCurrentRequestedMember } from '../../../features/screenshare/screenshare.slice';
import { TrackedEvents } from '../../../features/tracking/track';
import { useTrack } from '../../useTrack';

export const useSendScreenshareRequest = (): ((
  realtimeMemberId: string,
) => Promise<void>) => {
  const track = useTrack();
  const dispatch = useAppDispatch();
  const currentRequestedMemberId = useAppSelector(getCurrentRequestedMember);

  const sendScreenshareRequest = async (id: string): Promise<void> => {
    const retry = currentRequestedMemberId === id;

    await dispatch(
      realtime.sendMessage({
        id,
        message: {
          messageType: RealtimeMessageType.ScreenshareRequest,
          payload: { eventName: ScreenshareRequestPayload.Request },
        },
      }),
    );

    dispatch(setCurrentRequestedMember(id));
    void track(TrackedEvents.ScreenshareRequested, { retry });
  };

  return async (realtimeMemberId: string): Promise<void> => {
    await sendScreenshareRequest(realtimeMemberId);
  };
};
